// use-fetch-data.js
import { useEffect, useState } from "react";
import { GET_TEAMHEAD_DESIGNCONTRACTS } from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

interface Contract {
  customerName: string;
  id: number;
  conNumber: string;
  date: Date;
  projectCode: string;
}

interface Contracts {
  contracts: Contract[];
}

let val: Contracts;

const useFetchData = () => {
  const [data, setData] = useState(val);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await api.get(GET_TEAMHEAD_DESIGNCONTRACTS, null).then((response) => {
          setData(JSON.parse(JSON.stringify(response)));
          setLoading(false);
        });
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return {
    data,
    loading,
  };
};

export default useFetchData;
